module.exports = __webpack_public_path__ + "fonts/coffee.svg?v=a3b47eed2de2cc46a6d1d5bcf4fd84a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/coffee.svg
// module id = 690
// module chunks = 0